/** Convert kroner (possibly fractional) to integer øre. */
export function kr(kroner) {
    return Math.round(kroner * 100);
}
/** Convert integer øre to a kroner number (may be fractional). */
export function toKr(ore) {
    return ore / 100;
}
/** Round to whole øre (defensive — call after any float math). */
export function roundOre(ore) {
    return Math.round(ore);
}
//# sourceMappingURL=money.js.map